export const DEFAULT_IMAGE_URL =
  'https://firebasestorage.googleapis.com/v0/b/sr-server-e8ea5.appspot.com/o/Profile-Img.jpeg?alt=media&token=53ddffa0-0b30-48c2-9d14-20de6503198c';
